export default "__VITE_ASSET__DTOl$Dgf__"